// src/api/permission.js
import request from '@/utils/request';

const MOCK_MENU_DATA = {
  code: 200,
  message: "success",
  data: {
    menus: [
      {
        id: 1,
        type: "menu",
        path: "dashboard",  // ✅ 空路径作为 /admin 的默认子路由
        component: "Dashboard",
        name: "Dashboard",
        meta: {
          title: "仪表盘",
          icon: "el-icon-s-home",
          permissions: []
        },
        children: []
      },
      {
        id: 2,
        type: "menu",
        path: "orders",
        component: "OrderManage",
        name: "OrderManage",
        meta: {
          title: "订单管理",
          icon: "el-icon-document",
          permissions: [
            { id: 101, name: "查看订单", route: "view", type: "button" },
            { id: 102, name: "导出订单", route: "export", type: "button" }
          ]
        },
        children: []
      },
      {
        id: 3,
        type: "menu",
        path: "packages",
        component: "PackageManage",
        name: "PackageManage",
        meta: {
          title: "套餐管理",
          icon: "el-icon-box",
          permissions: [
            { id: 103, name: "新增套餐", route: "create", type: "button" },
            { id: 104, name: "编辑套餐", route: "edit", type: "button" }
          ]
        },
        children: []
      },
      {
        id: 4,
        type: "menu",
        path: "keys",
        component: "KeyManage",
        name: "KeyManage",
        meta: {
          title: "密钥管理",
          icon: "el-icon-key",
          permissions: [
            { id: 105, name: "生成密钥", route: "generate", type: "button" },
            { id: 106, name: "导出密钥", route: "export", type: "button" }
          ]
        },
        children: []
      },
      {
        id: 5,
        type: "menu",
        path: "customers",
        component: "CustomerManage",
        name: "CustomerManage",
        meta: {
          title: "客户管理",
          icon: "el-icon-user",
          permissions: [
            { id: 107, name: "新增客户", route: "add", type: "button" },
            { id: 108, name: "编辑客户", route: "edit", type: "button" },
            { id: 109, name: "删除客户", route: "delete", type: "button" }
          ]
        },
        children: []
      },
      {
        id: 6,
        type: "menu",
        path: "recharge-records",
        component: "RechargeRecords",
        name: "RechargeRecords",
        meta: {
          title: "充值记录",
          icon: "el-icon-document-copy",
          permissions: []
        },
        children: []
      },
      {
        id: 7,
        type: "menu",
        path: "ai-query",
        component: "AiQuery",  // ✅ 特殊路径，resolveComponent 会处理到 views/ai/
        name: "AiQuery",
        meta: {
          title: "AI小助手",
          icon: "el-icon-data-analysis",
          permissions: []
        },
        children: []
      },
      {
        id: 8,
        type: "menu",
        path: "user-profile",
        component: "UserProfile",
        name: "UserProfile",
        meta: {
          title: "用户参数配置",
          icon: "el-icon-setting",
          permissions: []
        },
        children: []
      },
      {
        id: 9,
        type: "menu",
        path: "permissions",
        component: "PermissionManage",
        name: "PermissionManage",
        meta: {
          title: "菜单配置",
          icon: "el-icon-menu",
          permissions: [
            { id: 110, name: "新增菜单", route: "add", type: "button" },
            { id: 111, name: "编辑菜单", route: "edit", type: "button" },
            { id: 112, name: "删除菜单", route: "delete", type: "button" }
          ]
        },
        children: []
      },
           // 系统管理（多级含三级）
           {
            id: 10,
            type: "menu",
            path: "system",
            component: "",
            name: "System",
            meta: {
              title: "系统管理",
              icon: "el-icon-setting",
              permissions: []
            },
            children: [
              {
                id: 101,
                type: "menu",
                path: "/system/users",
                component: "UserProfile",
                name: "UserProfile",
                meta: {
                  title: "用户管理",
                  icon: "el-icon-user",
                  permissions: []
                },
                children: []
              },
              {
                id: 102,
                type: "menu",
                path: "/system/permissions",
                component: "PermissionManage",
                name: "PermissionManage",
                meta: {
                  title: "菜单配置",
                  icon: "el-icon-menu",
                  permissions: []
                },
                children: []
              }
            ]
          },
    ]
  }
};
/**
 * 查询前端路由菜单（用于前端渲染）
 * @returns {Promise} 返回 { menus: [...] }
 */
export function getMenuRoutes() {
  // 开发环境：直接返回模拟数据，不发送真实请求
  // if (process.env.NODE_ENV === 'development') {
  //   return new Promise((resolve) => {
  //     // 模拟网络延迟（可选）
  //     resolve(MOCK_MENU_DATA);
  //   });
  // }
  return request({
    url: '/api/permissions/tree',
    method: 'get'
  });
}

/**
 * 查询权限管理树（后台维护权限使用，含完整字段）
 * @returns {Promise} 返回权限树列表
 */
export function getPermissionTree() {
  return request({
    url: '/api/permissions/tree',
    method: 'get'
  });
}

/**
 * 新增权限项
 * @param {Object} data
 * @param {string} data.type - menu / button
 * @param {string} data.route - 路由标识
 * @param {string} data.name - 名称
 * @param {number} data.parentId - 父级ID（可选）
 * @param {string} data.component - 组件路径（菜单必填）
 * @param {string} data.icon - 图标（可选）
 * @param {number} data.sortOrder - 排序（可选）
 * @returns {Promise}
 */
export function createPermission(data) {
  return request({
    url: '/api/permissions',
    method: 'post',
    data
  });
}

/**
 * 更新权限项
 * @param {number} id - 权限ID
 * @param {Object} data
 * @param {string} data.name - 名称
 * @param {string} data.route - 路由标识
 * @param {number} data.parentId - 父级ID（可选）
 * @param {string} data.component - 组件路径
 * @param {string} data.icon - 图标
 * @param {number} data.sortOrder - 排序
 * @returns {Promise}
 */
export function updatePermission(id, data) {
  return request({
    url: `/api/permissions/${id}`,
    method: 'put',
    data
  });
}

/**
 * 删除权限项
 * @param {number} id - 权限ID
 * @returns {Promise}
 */
export function deletePermission(id) {
  return request({
    url: `/api/permissions/${id}`,
    method: 'delete'
  });
}

// ===== 新增：查询用户已分配权限 =====
/**
 * 查询指定用户已分配的权限 ID 列表
 * @param {number} userId - 用户ID
 * @returns {Promise} 返回 { code, message, data: { permissionIds: [], permissionCodes: [] } }
 */
export function getUserPermissions(userId) {
  return request({
    url: `/api/users/${userId}/permissions`,
    method: 'get'
  });
}

/**
 * 分配用户权限（使用 permissionIds）
 * @param {number} userId - 用户ID
 * @param {Object} data - 请求体
 * @param {number[]} data.permissionIds - 权限ID列表
 * @param {string[]} data.permissionCodes - 权限码列表（可选，兼容旧版）
 * @returns {Promise}
 */
export function assignUserPermissions(userId, data) {
  return request({
    url: `/api/users/${userId}/permissions`,
    method: 'put',
    data
  });
}